import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Ahmed Moustafa </span>
            from <span className="purple"> Cairo, Egypt.</span>
            <br />
            I am currently searching for a role as a DevOps Engineer.
            <br />
            I have completed B.Sc. in Computer and Systems Engineering at Zagazig University with <span className="purple">Very Good</span> cumulative grade .
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Games
            </li>
            <li className="about-activity">
              <ImPointRight /> Writing Tech Blogs
            </li>
            <li className="about-activity">
              <ImPointRight /> Travelling
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "What I cannot create, I do not understand"{" "}
          </p>
          <footer className="blockquote-footer">Richard Feynman</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
